module.exports = __webpack_public_path__ + "fonts/f26faddb-86cc-4477-a253-1e1287684336.6b04d16.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/f26faddb-86cc-4477-a253-1e1287684336.woff
// module id = 156
// module chunks = 245 246